import './apps/hunter/portal/frontend/src/polyfills.ts';